import { render, staticRenderFns } from "./Componente.vue?vue&type=template&id=debe63a6&scoped=true"
import script from "./Componente.vue?vue&type=script&lang=js"
export * from "./Componente.vue?vue&type=script&lang=js"
import style0 from "./Componente.vue?vue&type=style&index=0&id=debe63a6&prod&lang=css"
import style1 from "./Componente.vue?vue&type=style&index=1&id=debe63a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debe63a6",
  null
  
)

export default component.exports